import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query";
export const baseUrl = process.env.API_ENDPOINT || '';
export const apiBaseQuery = () => fetchBaseQuery({
    baseUrl
});
export const api = createApi({
    reducerPath: "api",
    baseQuery: apiBaseQuery(),
    endpoints: (build) => ({})
});
//# sourceMappingURL=api.js.map